
import { ask_bot_Question, ask_bot_Question_database, ask_bot_with_file, ask_bot_with_file_and_database, cancel_bot_repos, delete_Thread_Messages, get_Thread_Messages, get_Thread_Messages_mongo, get_Thread_Messages_previous, get_transcription , thumb_up_message } from "../../helpers/fakebackend_helper";

import { set_temp_thread_title } from "../Thread/reducer";
import { ask_bot_fail, ask_bot_success, fetch_chat_history_error, fetch_chat_history_success, fetch_chat_history_success_append, set_sql_popup_button_details, set_transcription_text, set_typing_loader, start_ask_bot_loading, start_chat_loading, start_transcriptions_loading, stop_chat_loading } from "./reducer";





export const Bot_Chat_History = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(start_chat_loading())
    
       
    
      response = get_Thread_Messages(filterData);


      var data = await response;







      

        dispatch(fetch_chat_history_success(data));

   
    
  } catch (error) {
    dispatch(fetch_chat_history_error(error));
  }
};



export const Delete_Chat_Message = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(start_chat_loading())
    
       console.log(filterData)
    
      response = await delete_Thread_Messages(filterData);

     setTimeout(() => {
      
     }, 1000);

      response = get_Thread_Messages_mongo({session_id:filterData.thread_id});

      var data = await response







      

        dispatch(fetch_chat_history_success(data));


      var data = await response;



   
    
  } catch (error) {
    dispatch(fetch_chat_history_error(error));
  }
};


export const Bot_Chat_History_mongo = (filterData) => async (dispatch) => {



  try {
    let response;





    dispatch(start_chat_loading())
    
       
    
      response = get_Thread_Messages_mongo(filterData);


      var data = await response;







      

        dispatch(fetch_chat_history_success(data));

   
    
  } catch (error) {
    dispatch(fetch_chat_history_error(error));
  }
};


export const Bot_Ask_Message = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_ask_bot_loading())
      
         
      
        response = ask_bot_Question(filterData);
  
  
       let resposnse_data = await response;
  
  
  
       dispatch(ask_bot_success(resposnse_data));
  
     
      
    } catch (error) {
      dispatch(ask_bot_fail(error));
      dispatch(set_typing_loader(false))
    }
  };


  export const Bot_Ask_Message_with_file = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_ask_bot_loading())

      // console.log(filterData);
      
      
      let data = new FormData();
      // biome-ignore lint/complexity/noForEach: <explanation>
      filterData.files.forEach((ele)=>{
          // console.log(ele);
          
          data.append('file',ele)
       })

       if(filterData.audioBlob){
         data.append('file',filterData.audioBlob , 'recording.mp3')
       }


       data.append('streaming', true)
       data.append('bot_id',filterData.Bot_ID)
       data.append('assistant_id',filterData.assistant_id)
       data.append('message',filterData.message)
       data.append('thread_id',filterData.thread_id)
       data.append('databaseId',filterData.databaseId)
       data.append('model',filterData.model)
       data.append('instructions',filterData.instructions)
       data.append('number_of_rows',filterData.number_of_rows)
       data.append('language',filterData.selectedLanguage)
       data.append('websearch',filterData.websearch?'Yes':'No')
       data.append('vector_chunk_count', filterData.vector_chunk_count)
       

       
       
         
      
       response = ask_bot_with_file(data);
  
  
       let resposnse_data = await response;
  
  
  
       dispatch(ask_bot_success(resposnse_data));
       dispatch(set_temp_thread_title({ thread_id:filterData.thread_id , title:resposnse_data.title }))
  
     
      
    } catch (error) {
      dispatch(ask_bot_fail(error));
      dispatch(set_typing_loader(false))
    } finally{
      dispatch(set_typing_loader(false))
    }
  };



  export const Bot_Ask_Message_with_file_and_database = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_ask_bot_loading())

  
      
      let data = new FormData();
      filterData.files.forEach((ele)=>{
      
          
          data.append('files',ele)
       })



       data.append('bot_id',filterData.bot_id)
       data.append('message',filterData.message)
       data.append('thread_id',filterData.thread_id)
       data.append('databaseId',filterData.databaseId)
       data.append('model',filterData.model)
       data.append('instructions',filterData.instructions)
       data.append('sql_instructions',filterData.sql_instructions)
       data.append('number_of_rows',filterData.number_of_rows)
       data.append('language',filterData.selectedLanguage)
       data.append('websearch',filterData.websearch?'Yes':'No')
       data.append('sql_model', filterData.sql_model)
       data.append('vector_chunk_count', filterData.vector_chunk_count)
       data.append('send_sql_to_llm',filterData.send_sql_to_llm)
       
         
      
       response = ask_bot_with_file_and_database(data);
  
  
       let resposnse_data = await response;
  
  
  
       dispatch(ask_bot_success(resposnse_data));
      dispatch(set_temp_thread_title({ thread_id:filterData.thread_id , title:resposnse_data.title }))
  
     
      
    } catch (error) {
      dispatch(ask_bot_fail(error));
      dispatch(set_typing_loader(false))
    } finally{
      dispatch(set_typing_loader(false))

    }
  };


  export const Bot_Ask_Message_with_data_base = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
     dispatch(set_sql_popup_button_details({  popup_open_state:false , query:""  }))
  
  
      dispatch(start_ask_bot_loading())
      
         
      
        response = ask_bot_Question_database(filterData);
  
  
       let resposnse_data = await response;

       if(resposnse_data.Query && resposnse_data.Query.length>0){
        dispatch(set_sql_popup_button_details({  popup_open_state:true , query:resposnse_data.Query  }))
       }else{
        dispatch(set_sql_popup_button_details({  popup_open_state:false , query:""  }))
       }
  
  
  
       dispatch(ask_bot_success(resposnse_data));
  
     
      
    } catch (error) {
      dispatch(ask_bot_fail(error));
      dispatch(set_typing_loader(false))
    }
  };


  export const Bot_Chat_History_Append = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_chat_loading())
      
         
      
        response = get_Thread_Messages_previous(filterData);
  
  
        var data = await response;
  
  
  
  
  
  
  
        if(data.length > 0){

          dispatch(fetch_chat_history_success_append(data));
        }
  
  
     
      
    } catch (error) {
      dispatch(fetch_chat_history_error(error));
    }
  };


  export const Bot_Chat_History_Append_mongo = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_chat_loading())
      
         
      
        response = get_Thread_Messages_mongo(filterData);
  
  
        var data = await response;
  
  
  
  
  
    
  
        if(data.length > 0){
    
          dispatch(fetch_chat_history_success_append(data));
        }
  
  
     
      
    } catch (error) {
      dispatch(fetch_chat_history_error(error));
    }
  };



  export const Bot_Chat_Cancel = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_chat_loading())
      
         
      
        response = cancel_bot_repos(filterData);
  
  
        var data = await response;
  
  
  

        dispatch(stop_chat_loading(data));
  
     
      
    } catch (error) {
      // dispatch(fetch_chat_history_error(error));
      dispatch(set_typing_loader(false))
    } finally{
      // dispatch(set_typing_loader(false))
    }
  };


  export const Bot_Speech_Text_file = (filterData) => async (dispatch) => {



    try {
      let response;
  
  
  
  
  
      dispatch(start_transcriptions_loading())

      // console.log(filterData);
      
      
      let data = new FormData();
    

       if(filterData.audioBlob){
         data.append('audio_file',filterData.audioBlob , 'recording.mp3')
       }





       
       
         
      
       response = get_transcription(data);
  
  
       let resposnse_data = await response;
  
  
  
       dispatch(set_transcription_text(resposnse_data.transcription));
    
  
     
      
    } catch (error) {
       dispatch(set_transcription_text(" "));
       console.log(error);
       
    }
  };


  
  export const THUMB_UP_MESSAGE = (filterData) => async (dispatch) => {



    try {
      let response;
  
         
      
       response = thumb_up_message(filterData);

       await response

      
    } catch (error) {

       console.log(error);
       
    }
  };

  




  

